var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-tabs',{model:{value:(_vm.subTabActiveName),callback:function ($$v) {_vm.subTabActiveName=$$v},expression:"subTabActiveName"}},[_c('el-tab-pane',{attrs:{"label":"舌象症状配置","name":"first"}},[_c('TongueAppearance')],1),_c('el-tab-pane',{attrs:{"label":"舌诊副症状配置","name":"second"}},[_c('SubSymptomConfig')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }